<template>
<div class="container-box">
    <div :id="id" :style="{height:height,width:width}"></div>
</div>
</template>

<script>
import echarts from 'echarts';
export default {
    props: ['className', 'id', 'height', 'width', 'title', 'echartsData'],
    data() {
        return {}
    },
    mounted() {
        let result = this.echartsData;
        let data1 = [],
            data2 = [],
            dataAxis = [];
        result.map((item, index) => {
            dataAxis.push({
                value: item.days ? item.days : index + 1,
                textStyle: {
                    color: '#04C3F1'
                }
            })
            data1.push(item.callNum)
            data2.push(item.disposeNum)
        })
        this.initData(data1.reverse(), data2.reverse(), dataAxis.reverse());
    },
    beforeDestroy() {

    },
    methods: {

        initData(data1, data2, dataAxis) {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById(this.id))
            // 绘制图表
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    position: ['10px', '10px']
                },
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '5%',
                    top: '5%',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    show: false,
                    boundaryGap: [0, 0.01]
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    data: dataAxis
                },
                series: [{
                    name: '接警',
                    type: 'bar',
                    label: {
                        show: false,
                        position: 'top',
                        color: '#04C3F1'
                    },
                    barWidth: '20%',
                    data: data1
                }, {
                    name: '出警',
                    type: 'bar',
                    label: {
                        show: false,
                        position: 'top',
                        color: '#04C3F1'
                    },
                    barWidth: '20%',
                    data: data2
                }],
                color: {
                    type: 'linear',
                    x: 0,
                    y: 1,
                    x2: 0,
                    y2: 0,
                    colorStops: [{
                        offset: 0,
                        color: 'transparent' // 0% 处的颜色
                    }, {
                        offset: 1,
                        color: '#04C3F1' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                }
            })
        },

    }
}
</script>

<style lang="less" scoped>
</style>
